import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    q: "How is this different from large coaching institutes?",
    a: "We maintain a strict batch size of 30 students, ensuring personal attention, individualized strategy, and direct mentor access. Unlike large institutes, every student's progress is tracked and addressed.",
  },
  {
    q: "Will I get personal attention?",
    a: "Yes. With a maximum of 30 students per batch, each student receives personalized strategy reviews, doubt resolution, and direct mentorship throughout the program.",
  },
  {
    q: "Are classes recorded?",
    a: "Yes. All live sessions are recorded and made available for later review. You'll have access to recorded sessions throughout the program duration.",
  },
  {
    q: "Is there a refund policy?",
    a: "Please reach out to us directly to discuss refund terms. We are transparent about our policies and happy to address any concerns before enrollment.",
  },
  {
    q: "How many hours per week are required?",
    a: "We recommend dedicating 15-20 hours per week for optimal preparation. This includes live sessions, self-study, mock tests, and analysis time.",
  },
  {
    q: "Who is this program suitable for?",
    a: "This program is designed for Class 11-12 students seriously preparing for CLAT UG (2026/2027). It's ideal for aspirants who value structured mentorship over mass coaching.",
  },
];

export default function FAQSection() {
  return (
    <section
      id="faqs"
      data-testid="faq-section"
      className="py-20 md:py-32 bg-orange-50/40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Left */}
          <div className="lg:col-span-4">
            <span className="text-sm font-semibold tracking-wider uppercase text-orange-600 font-body">
              Questions
            </span>
            <h2
              data-testid="faq-title"
              className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-zinc-900 tracking-tight leading-tight mt-4"
            >
              Frequently Asked Questions
            </h2>
            <p className="font-body text-base text-zinc-500 leading-relaxed mt-5">
              Have more questions? Reach out to us via email or WhatsApp.
            </p>
          </div>

          {/* Right */}
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="space-y-3">
              {faqs.map((faq, idx) => (
                <AccordionItem
                  key={idx}
                  value={`faq-${idx}`}
                  data-testid={`faq-item-${idx}`}
                  className="bg-white rounded-xl border border-zinc-100 px-6 data-[state=open]:shadow-sm transition-shadow"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${idx}`}
                    className="font-body text-base text-left font-medium text-zinc-800 hover:text-orange-600 transition-colors py-5 hover:no-underline"
                  >
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${idx}`}
                    className="font-body text-sm text-zinc-500 leading-relaxed pb-5"
                  >
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
